import { h } from 'preact';
import LocationsList from '../locations-list';
import IconListItem from '../icon-list-item';
import style from './style';

export default function PrimaryLocation({ location, onSetCurrent, ...props }) {
	return (
		<LocationsList hideHeader>
			<IconListItem
				location={location}
				class={style.primaryLocation}
				icon="current-location-wire-cube"
				onClickLocation={onSetCurrent}
			/>
		</LocationsList>
	);
}
